import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

export default function TerminosCondiciones() {
  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Terminos y Condiciones' }]} />
      <div style={{ maxWidth:860, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:42, color:'var(--forest)', marginBottom:8 }}>Terminos y Condiciones</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:32 }} />
        <p style={{ fontSize:13, color:'var(--ink-faint)', marginBottom:32 }}>Ultima actualizacion: Abril 2026</p>

        {[
          {
            titulo: '1. Aceptacion',
            texto: 'Al acceder y usar wawita.co, usted acepta estos terminos y condiciones. Si no esta de acuerdo, le pedimos no usar nuestro sitio. Wawita Eco Friendly se reserva el derecho de modificar estos terminos en cualquier momento.'
          },
          {
            titulo: '2. Productos y precios',
            texto: 'Todos los precios estan en pesos colombianos (COP) e incluyen IVA cuando aplica. Nos reservamos el derecho de modificar precios sin previo aviso. Las fotos de los productos son ilustrativas; los colores pueden variar segun el dispositivo.'
          },
          {
            titulo: '3. Proceso de compra',
            texto: 'El pedido se confirma una vez verificado el pago. Wawita Eco Friendly se reserva el derecho de cancelar pedidos en caso de error en precios, falta de stock o informacion incorrecta del comprador. En caso de cancelacion, se realizara el reembolso correspondiente.'
          },
          {
            titulo: '4. Metodos de pago',
            texto: 'Aceptamos pagos via Nequi y Bre-B (transferencia por llave). El pedido se procesa una vez confirmado el pago. El comprobante debe enviarse por WhatsApp al +57 311 340 7979.'
          },
          {
            titulo: '5. Envios y entregas',
            texto: 'Realizamos envios a todo Colombia. El tiempo de entrega es de 1 dia en Pasto y 2 a 5 dias habiles para el resto del pais. Los costos de envio se calculan al momento del pago. Wawita no se hace responsable por demoras causadas por la transportadora o fuerza mayor.'
          },
          {
            titulo: '6. Cambios y devoluciones',
            texto: 'Aceptamos cambios y devoluciones dentro de los 5 dias habiles siguientes a la recepcion del producto, siempre que este en perfectas condiciones, sin uso y en su empaque original. Productos de higiene personal no tienen cambio por razones sanitarias, excepto defecto de fabrica.'
          },
          {
            titulo: '7. Sistema Refill',
            texto: 'El sistema de recarga aplica solo para envases originales de Wawita en buen estado. El descuento de recarga no es acumulable con otras promociones. Wawita se reserva el derecho de rechazar envases en mal estado.'
          },
          {
            titulo: '8. Propiedad intelectual',
            texto: 'Todos los contenidos del sitio (imagenes, textos, logos, formulas) son propiedad de Wawita Eco Friendly. Queda prohibida su reproduccion total o parcial sin autorizacion expresa.'
          },
          {
            titulo: '9. Limitacion de responsabilidad',
            texto: 'Wawita Eco Friendly no sera responsable por danos indirectos, incidentales o consecuentes derivados del uso de sus productos. La responsabilidad maxima se limita al valor del producto adquirido.'
          },
          {
            titulo: '10. Ley aplicable',
            texto: 'Estos terminos se rigen por las leyes de la Republica de Colombia. Cualquier disputa sera resuelta ante los tribunales competentes de Pasto, Narino. Para dudas: contacto@wawitaeco.com'
          },
        ].map(s => (
          <div key={s.titulo} style={{ marginBottom:32 }}>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:20, color:'var(--forest)', marginBottom:12 }}>{s.titulo}</h2>
            <p style={{ fontSize:15, color:'var(--ink-mid)', lineHeight:1.8 }}>{s.texto}</p>
          </div>
        ))}

        <div style={{ background:'rgba(159,190,106,0.1)', borderRadius:16, padding:24, marginTop:40 }}>
          <p style={{ fontSize:14, color:'var(--forest)', fontWeight:600, textAlign:'center' }}>
            Wawita Eco Friendly · Pasto, Narino, Colombia<br/>
            contacto@wawitaeco.com · +57 311 340 7979
          </p>
        </div>
      </div>
    </div>
  );
}
